import { NextPage } from 'next';
import { JIBTable } from './JIBTable';
import { useRouter } from 'next/router';
import { useLocalization } from '~/framework';
import { PageContainer } from '~/ui-components';
import { ActiveNavItem, ErrorPage } from '~/page-components/Layout';
import { PageBar, PageTitle, useSiteInfo } from '../_shared';
import { Center, CircularProgress, Text } from '@chakra-ui/react';
import { useJIBTableContext, JIBTableProvider } from './JIBTable/JIBTableContext';

type ContentProps = {
   releaseid: number | null;
};

function Content({ releaseid }: ContentProps) {
   const { _js } = useLocalization();
   const { guide, isFetching } = useJIBTableContext();

   if (isFetching) {
      return (
         <Center height="100vh" width="100vw">
            <CircularProgress isIndeterminate />
         </Center>
      );
   } else if (guide) {
      return (
         <>
            <PageTitle>{_js('Job Instruction Breakdown')}</PageTitle>
            <ActiveNavItem value="guides" />
            <PageContainer maxW="container.xl">
               <PageBar useNativeBackNavigation />
               <Text as="h1" mt="15px">
                  {guide.title}
               </Text>
               <JIBTable />
            </PageContainer>
         </>
      );
   } else {
      return <ErrorPage error={{ code: 404 }} />;
   }
}

const GuideJIBPage: NextPage = () => {
   const router = useRouter();
   const { data: siteInfo } = useSiteInfo();
   const guideid = Number(router.query.guideid);
   const releaseid = isNaN(Number(router.query.releaseid)) ? null : Number(router.query.releaseid);

   if (!siteInfo?.['feature-job-instruction-breakdowns']) {
      return <ErrorPage error={{ code: 404 }} />;
   }

   return (
      <JIBTableProvider guideid={guideid} releaseid={releaseid}>
         <Content releaseid={releaseid} />
      </JIBTableProvider>
   );
};

export default GuideJIBPage;
